import { HolidaysState } from '.';
import { GetterTree } from 'vuex';
import { AppState } from '../app';
import { HolidayViewModel } from '@/features/bots/models/holidayViewModel';

export const getters: GetterTree<HolidaysState, AppState> = {
  getHoliday(state: HolidaysState): (holidayId: string) => HolidayViewModel | undefined {
    return (holidayId: string) => {
      return state.holidays.find((holiday) => holiday.id === holidayId);
    };
  },

  holidays(state: HolidaysState): HolidayViewModel[] {
    return state.holidays;
  },
};
